import React from "react";

const dummyCerts = [
  { name: "ISO 9001", issuedBy: "Bureau Veritas", expiry: "2026-01-01" },
  { name: "CE Marking", issuedBy: "EU Standards", expiry: "2025-12-31" },
  { name: "BIS Certification", issuedBy: "BIS India", expiry: "2027-05-15" },
];

export default function SyntraMfgCertificatesPage({ onClose }) {
  return (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-700">Certifications (Dummy Data)</h3>
      <div className="grid md:grid-cols-2 gap-4">
        {dummyCerts.map((c, idx) => (
          <div key={idx} className="border rounded-lg p-4 bg-gray-50">
            <p className="font-semibold">{c.name}</p>
            <p className="text-sm text-gray-500">Issued By: {c.issuedBy}</p>
            <p className="text-sm text-gray-500">Expiry: {c.expiry}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
